<div id="goBackButtonContainer" *ngIf="!trainsInfo?.isAdmin">
  <button mat-button mat-flat-button (click)="goBack()">
    <img src="assets/img/svg/arrow-back.svg" alt="" width="24px" />
  </button>
</div>
<app-user-detail *ngIf="(trainsInfo?.isAdmin && trainsInfo?.canUseTRM) || trainsInfo?.isEmployee" [userUuid]="trainsInfo?.userToBook"
  (navigateEvent)="goBack()"></app-user-detail>

<mat-horizontal-stepper linear [linear]="true" #stepper>
  <ng-template matStepperIcon="edit" let-index="index">
    {{ index + 1 }}
  </ng-template>
  <mat-step label="{{ 'flight.passengers-data' | translate }}" #first_step>
    <ng-container *ngIf="stepper.selected == null || stepper.selected == first_step">
      <app-train-passenger-form [stepper]="stepper"></app-train-passenger-form>
    </ng-container>
  </mat-step>
  <mat-step *ngIf="trainsInfo?.canChooseExtra || trainsInfo?.canChooseSeat" label="{{ 'train.confirm-stepper-container.stepper.seats-and-extras' | translate }}" #second_step>
    <ng-container *ngIf="stepper.selected == second_step">
      <app-train-extra-selection [stepper]="stepper"></app-train-extra-selection>
    </ng-container>
  </mat-step>
  <mat-step label="{{ 'flight.pucharse-confirmation' | translate }}" #fourth_step>
    <ng-container *ngIf="stepper.selected == fourth_step">
      <app-confirm-booking [stepper]="stepper"></app-confirm-booking>
    </ng-container>
  </mat-step>
</mat-horizontal-stepper>